import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth, dashboardPathFor } from '../lib/auth';

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = () => { logout(); nav('/', { replace: true }); };

  return (
    <nav className="ap-nav" data-testid="main-navbar">
      <div className="container d-flex align-items-center justify-content-between py-3">
        <Link to="/" className="brand d-flex align-items-center" data-testid="nav-brand">
          <img 
            src="https://businessprideindia.com/bu_images/logo-bp.jpeg" 
            alt="Business Pride" 
            style={{
              height: '40px',
              width: 'auto',
              marginRight: '10px',
              objectFit: 'contain'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              // Fallback to text if image fails to load
              const span = document.createElement('span');
              span.className = 'brand-dot';
              span.setAttribute('aria-hidden', 'true');
              e.target.parentNode.insertBefore(span, e.target);
            }}
          />
          <span style={{ display: 'inline-block' }}>Business Pride</span>
        </Link>
        <div className="d-none d-lg-flex align-items-center gap-1">
          <NavLink to="/search" className="nav-link px-3" data-testid="nav-search">Search</NavLink>
          <NavLink to="/categories" className="nav-link px-3" data-testid="nav-categories">Categories</NavLink>
          <NavLink to="/cities" className="nav-link px-3" data-testid="nav-cities">Cities</NavLink>
          <NavLink to="/payments" className="nav-link px-3" data-testid="nav-payments">Payments</NavLink>
        </div>
        <div className="d-flex align-items-center gap-2">
          {!user && (
            <>
              <Link to="/login" className="btn-ap-outline" data-testid="nav-login-btn">Log in</Link>
              <Link to="/register" className="btn-ap" data-testid="nav-register-btn">Get started</Link>
            </>
          )}
          {user && (
            <>
              <Link to={dashboardPathFor(user.role)} className="btn-ap-outline" data-testid="nav-dashboard-btn">
                Dashboard
              </Link>
              <button className="btn-ap-outline" onClick={handleLogout} data-testid="nav-logout-btn">Logout</button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}